import React from "react";
import { MdClose } from "react-icons/md";
import Alert from "../Alert";
import getErrorMessage from "../../errors/getErrorMessage";
import isConnectivityError from "../../helpers/isConnectivityError";

/**
 * Inline replacement for toasting API errors. Renders nothing when there is
 * no error, so it can sit unconditionally near the top of a form/screen/card.
 */
const ApiErrorAlert = ({ error, className = "", onClose }) => {
  // Backend fora do ar não é erro da ação: a sidebar já mostra a queda
  if (!error || isConnectivityError(error)) return null;

  return (
    <Alert severity="error" className={`mb-3 ${className}`}>
      <div className="flex items-center justify-between gap-3">
        <span>{getErrorMessage(error)}</span>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 border-0 bg-transparent p-0 text-red-700 hover:text-red-900"
            aria-label="Fechar"
          >
            <MdClose size={16} />
          </button>
        )}
      </div>
    </Alert>
  );
};

export default ApiErrorAlert;
